export default __webpack_public_path__ + "static/media/rr6.99c4989d.jpg";